import { IRegion } from '@novakid/ts-types';

import { CONFIG } from 'config';

interface SignUnURLProps {
  region?: IRegion;
}

export function getSignUpUrl({ region }: SignUnURLProps) {
  if (!region || !region.links?.landing?.url) return `${CONFIG.DEFAULT_LANDING_URL}/registration`;

  const regionLang = region.language;
  const landingUrl = region.links.landing.url;

  const { origin, pathname } = parseUrl(landingUrl);
  const isSubFolder = Boolean(pathname.split('/')[1]);

  return `${origin}/registration${isSubFolder ? `/${regionLang}` : ''}`;
}

function parseUrl(url: string) {
  const match = url.match(/^(https?:\/\/[^/]+)(\/[^?#]*)?/i);
  return {
      origin: match && match[1] ? match[1] : '',
      pathname: match && match[2] ? match[2] : '/'
  };
}